import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const partnerApi = createApi({
  reducerPath: 'partnerApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Partner', 'Partners'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
